import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { SlaughterService } from '../../services/slaughter.service';
import { formatDateOnlyISO } from '../../utils/date-utils';
import { PlantService } from '../../services/plant.service';
import { CustomerService } from '../../services/customer.service';
import { ReportService } from '../../services/report-service';
import { showToast } from '../../utils/misc/toast-utils';
import { ClassificationService } from '../../services/classification.service';
export const loading = writable(false);
export const filter = writable({ criteria: { refDate: formatDateOnlyISO(new Date()) } });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export const currentSrcCustomer = writable(null);
export const currentUtilizationCode = writable(null);
export async function initList() {
    let refDate = formatDateOnlyISO(new Date());
    filter.set({ criteria: { refDate: refDate }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    var _a, _b, _c, _d;
    record.set(null);
    stats.set(null);
    currentSrcCustomer.set(null);
    currentUtilizationCode.set(null);
    let prepareDto = await fetchSlaughterPrepareData();
    if (oid == 0) {
        record.set({
            oid: 0,
            protocol: '',
            phaseCode: (_a = prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.phaseCode) !== null && _a !== void 0 ? _a : "M", //'M',
            originCode: (_b = prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.plantOriginCode) !== null && _b !== void 0 ? _b : '',
            plantId: (_c = prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.plantId) !== null && _c !== void 0 ? _c : null,
            working: 0,
            completed: 0,
            active: 1,
            slaughterDate: prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.slaughterDate, // get(filter).criteria.refDate,
            dailyNumber: (_d = prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.dailyNumber) !== null && _d !== void 0 ? _d : 0,
            //srcCustomerId: 0,
            //srcCarrierId: 0,
            srcDdtNumber: '',
            srcDdtDate: '',
            srcInvoiceNumber: '',
            srcInvoiceDate: '',
            srcCod317: '',
            //srcCod317Id: 0,
            totQuantity: 0,
            totWeight: 0,
            avgWeight: 0,
            //clfUtilizationId: 0,
            utilizationNotes: '',
            letterNumber: '',
            mod4Number: '',
            clfPurposeId: prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.clfPurposeId,
            clfProcessingTypeId: prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.clfProcessingTypeId,
            //dstCustomerId: 0,
            //dstCustomerAddressId: 0,
            //dstCarrierId: 0,
            dstDdtNumber: '',
            dstDdtDate: '',
            dstInvoiceNumber: '',
            dstInvoiceDate: '',
            clfRaisingTypeId: prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.clfRaisingTypeId,
            roomTypeId: prepareDto === null || prepareDto === void 0 ? void 0 : prepareDto.roomTypeId,
            hotTransportExecuted: 0,
            hotTransportCooled: 0,
            trc: 0,
            autoDdt: 0,
            notes: ''
        });
    }
    else {
        let _resp = await SlaughterService.fetchSlaughter(oid);
        record.set(_resp.payload);
        if (_resp.payload.srcCustomerId) {
            let srcCustomer = await CustomerService.fetchCustomer(_resp.payload.srcCustomerId);
            currentSrcCustomer.set(srcCustomer.payload);
        }
        if (_resp.payload.clfUtilizationId) {
            let utilization = await ClassificationService.fetchValue(_resp.payload.clfUtilizationId);
            currentUtilizationCode.set(utilization.payload.code);
        }
        await loadStats(oid);
    }
}
async function loadStats(oid) {
    //let _resp = await BookingService.fetchBookingStats(bookingOid);
    //stats.set(_resp.payload);
}
async function fetchSlaughterPrepareData() {
    let _filter = get(filter);
    let _resp = await SlaughterService.slaughterPrepare(_filter);
    return _resp ? _resp.payload : null;
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await SlaughterService.getSlaughters(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/butcher-work/slaughter/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/butcher-work/slaughter/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await SlaughterService.saveSlaughter(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await SlaughterService.deleteSlaughter(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export function onDateFilterChanged(evt) {
    let date = evt.detail;
    if (!date)
        return;
    let _filter = get(filter);
    filter.set(Object.assign(Object.assign({}, _filter), { criteria: Object.assign(Object.assign({}, _filter.criteria), { refDate: date }) }));
    search();
}
export async function onPlantSelected(item) {
    if (item == null)
        return;
    let _resp = await PlantService.fetchPlant(item.oid);
    let plant = _resp.payload;
    record.set(Object.assign(Object.assign({}, get(record)), { originCode: plant.originCode }));
}
export async function onSrcCustomerSelected(item) {
    if (item == null) {
        currentSrcCustomer.set(null);
        return;
    }
    fillCustomerExtras(item.oid, true);
}
export async function fillCustomerExtras(customerId, resetCod317) {
    let _resp = await CustomerService.fetchCustomer(customerId);
    let customer = _resp.payload;
    if (customer)
        currentSrcCustomer.set(customer);
    let _curr = get(record);
    let autoDdt = !!customer && customer.ownCompany == 0 ? 1 : 0;
    if (resetCod317)
        //record.set({ ..._curr, srcCod317: '', srcCod317Id: null!, autoDdt: autoDdt });
        _curr = Object.assign(Object.assign({}, _curr), { srcCod317: '', srcCod317Id: null, autoDdt: autoDdt });
    else
        //record.set({ ..._curr, autoDdt: autoDdt });
        _curr = Object.assign(Object.assign({}, _curr), { autoDdt: autoDdt });
    /*
    if (!!customer && !!customer.cod317) {
      record.set({ ..._curr, srcCod317: customer.cod317, autoDdt: autoDdt });
    } else {
      record.set({ ..._curr, srcCod317: "", autoDdt: autoDdt });
    }
    */
    if (customer)
        _curr = Object.assign(Object.assign({}, _curr), { hotTransportExecuted: customer.hotTransportExecuted, hotTransportCooled: customer.hotTransportCooled, trc: customer.trc });
    record.set(Object.assign({}, _curr));
}
export async function onUtilizationSelected(item) {
    currentUtilizationCode.set(item ? item.code : null);
}
export async function startWork() {
    let _record = get(record);
    await SlaughterService.startSlaughterWork(_record.oid);
    record.set(null);
    let _resp = await SlaughterService.fetchSlaughter(_record.oid);
    record.set(_resp.payload);
}
export async function stopWork() {
    let _record = get(record);
    await SlaughterService.stopSlaughterWork(_record.oid);
    record.set(null);
    let _resp = await SlaughterService.fetchSlaughter(_record.oid);
    record.set(_resp.payload);
}
export async function assignLotNumbers() {
    let _filter = get(filter);
    await SlaughterService.assignLotNumbers(_filter);
    await load();
    showToast(`Lotti assegnati`, 'is-success');
}
export async function downloadDailySlaughterReport() {
    let criteria = { slaughterDate: get(filter).criteria.refDate };
    let dto = { criteria: criteria, params: null, sorting: "" };
    ReportService.exportPdfDailySlaughter(dto);
}
export async function downloadDestinazioneCarcasseReport() {
    let criteria = { slaughterDate: get(filter).criteria.refDate };
    let dto = { criteria: criteria, params: null, sorting: "" };
    ReportService.exportPdfDestinazioneCarcasse(dto);
}
export async function downloadDichiarazioneUsoDomesticoReport() {
    let _record = get(record);
    if (_record != null && _record.oid != 0) {
        ReportService.exportPdfDichiarazioneUsoDomestico(_record.oid);
    }
}
